export default __webpack_public_path__ + "static/media/polygon-delete.0638e342.svg";